package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.*
import com.downdogapp.client.controllers.PlaylistViewController
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.StructuredRow.Companion.structuredRow

actual class PlaylistView actual constructor(
  private val controller: PlaylistViewController
) : TopLevelView(), View {

  override val root = controllerView {
    bg = if (AppPage.displayingAbovePlayback) {
      background(image = postPracticeBackgroundImage) {
        filter = Filter.blur(px(10))
      }
    } else {
      background(true)
    }
    fg = foreground(!AppPage.displayingAbovePlayback) {
      centeredColumnView {
        pageHeader(
          title = Strings.SONGS_PLAYED,
          onBackClicked = controller::onBackClicked
        )

        div {
          height = px(1)
          bgColor = Color.grey(0.4)
          (HORIZONTAL_CONTENT_GUTTER_PX - px(5)).let {
            marginLeft = it
            marginRight = it
          }
          marginTop = px(1) * -1
        }

        tableView(::getContents) {
          marginBottom = px(80)
        }
      }
    }
  }

  private fun getContents() = TableContents(
    rows = controller.songs.map { song ->
      structuredRow(
        height = px(70),
        allowSeparator = true,
        clickFn = { controller.onSongClicked(song) }
      ) {
        leftImage(imageSrc = MANIFEST.artworkUrlPrefix + song.artwork)
        leftTextContent(text = song.title, subtext = song.artist)
        rightArrow()
      }
    },
    separator = fullWidthSeparator
  )
}
